import fetch from "auth/FetchInterceptor";

const ataEncaminhamentosService = {};

ataEncaminhamentosService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/ata-referrals",
		method: "get",
		params,
	});
};

ataEncaminhamentosService.post = function (data) {
	return fetch({
		url: "/v1/rest/ata-referrals",
		method: "post",
		data: data,
	});
};

ataEncaminhamentosService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/ata-referrals/${id}`,
		method: "put",
		data: data,
	});
};

ataEncaminhamentosService.postPrazo = function (data) {
	return fetch({
		url: `/v1/rest/ata-referrals-deadlines`,
		method: "post",
		data: data,
	});
};

ataEncaminhamentosService.getPrazoChanges = function (id) {
	return fetch({
		url: `/v1/rest/ata-referrals-deadlines-list/${id}`,
		method: "get",
	});
};

ataEncaminhamentosService.getById = function (id) {
	return fetch({
		url: `/v1/rest/ata-referrals/${id}`,
		method: "get",
	});
};

ataEncaminhamentosService.getListById = function (id) {
	return fetch({
		url: `/v1/rest/ata-referrals-list/${id}`,
		method: "get",
	});
};

ataEncaminhamentosService.del = function (id) {
	return fetch({
		url: `/v1/rest/ata-referrals/${id}`,
		method: "delete",
	});
};

export default ataEncaminhamentosService;
